import { Link } from "react-router-dom";

export default function MobileApp ({darkMode, appInfo}) {

    const appStoreIcon = darkMode ? "/app-store-light.svg" : "/app-store-dark.svg";
    const playStoreIcon = "/play-store.png";
    const iconAlt = `${appInfo.name} app store icon`;

    function IsPublished() {
        if (appInfo.published) {
            return (
                <div className="flex items-center justify-around w-full">
                    <div className="flex flex-col">
                        <a href={appInfo.appStoreLink} target="_blank" rel="noreferrer">
                            <img alt="download on app store" src={appStoreIcon} />
                        </a>
                        {appInfo.playStoreLink &&
                            <a href={appInfo.playStoreLink} target="_blank" rel="noreferrer">
                                <img className='w-[120px] mt-2' alt="download on play store" src={playStoreIcon} />
                            </a>
                        }
                    </div>
                    
                    <Link to={appInfo.pageLink}>
                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </Link>
                </div>
            )
        }
        else {
            return (
                <div className="small-p italic p-2 rounded">
                    coming soon...
                </div>
            )
        }
    }

    return (
        <div className="p-4 m-1 mobile-app flex flex-col items-center justify-around rounded w-64">
            <h3 className="big-p font-bold">{appInfo.name}</h3>
            <img alt={iconAlt} className="w-40 rounded" src={appInfo.icon} />
            <p className="small-p p-1 text-center">{appInfo.description}</p>
            <IsPublished />
        </div>
    )
}